import React from 'react';
import { Spin } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { LoadingRow } from './style';

interface LoadingProps {
  height?: number;
  spinSize?: React.ComponentProps<typeof Spin>['size'];
  error?: {
    message: string;
  };
}

const Loading = function ({
  height = 50,
  spinSize = 'default',
  error = undefined,
}: LoadingProps) {
  return (
    <LoadingRow
      justify="center"
      $height={height}
    >
      <Spin
        size={spinSize}
        indicator={error ? <ExclamationCircleOutlined /> : undefined}
      />
    </LoadingRow>
  );
};

export default Loading;
